
import { MdSearch } from "react-icons/md";
import styled from "styled-components";
import { Button, Card, Container, Dropdown, Form } from "react-bootstrap";

export const Box = styled.div`
  display: flex;
  align-items: center;
`;


export const CardIcon = styled.div`
  width: 56px;
  height: 56px;
  background-color: ${({ theme }) => theme.colors.background_icon};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.primary};
  margin-right: 16px;
`;
export const FilterContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  gap: 8px;
`;

export const CardHeader = styled(Card.Header)`
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.shape};
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  flex-wrap: wrap;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.secundary};
  margin: 0;
`;

export const ContainerMain = styled(Container)`
  margin-top: 56px;
  margin-bottom: 20px;
`;

export const ButtonLink = styled.button`
  all: unset;
`;

export const NoFoundData = styled.h4`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

export const CardFooterCustom = styled(Card.Footer)`
  background-color: ${({ theme }) => theme.colors.shape};
  display: flex;
  justify-content: end;
`;

export const SelectFilter = styled(Form.Select)`
  border: 1.5px solid #e1e6ef;
  border-radius: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: #1e212a;
  max-width: 142px;
  height: 44px;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 10px;
  }
`;

export const IconSearch = styled(MdSearch)`
  color: #1e212a;
`;

export const DropdownCustom = styled(Dropdown)`
  .dropdown-toggle::after {
    display: none !important;
  }
  .drop-button {
    background-color: #f8f9fa00;
    border: 1px solid #e1e6ef;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const CustomButton = styled(Button)`
  background-color: ${({ theme, variant }) => variant === 'filter' ? theme.colors.primary : 'transparent'};
  border-color: ${({ theme, variant }) => variant === 'filter' ? 'rgb(225, 230, 239)' : theme.colors.primary} !important;
  color: ${({ theme, variant }) => variant === 'filter' ? '#fff' : theme.colors.primary};

  :hover, :active, :focus {
    background-color: ${({ theme, variant }) => variant === 'filter' ? '#fff' : theme.colors.primary} !important;
    border-color: ${({ theme, variant }) => variant === 'filter' ? theme.colors.primary : theme.colors.primary} !important;
    color: ${({ theme, variant }) => variant === 'filter' ? theme.colors.primary : "#fff"} !important;
  }

  :hover > .icon, :active > .icon, :focus > .icon {
    color: #fff !important;
  }
`;
